import RetroDashboardContent from '../components/retro/RetroDashboardContent';

/**
 * Dashboard - Mission Control homepage
 * Shows ASCII mission control visualization with app metrics and activity
 */
function Dashboard() {
    return <RetroDashboardContent />;
}

export default Dashboard;
